// import React, { lazy, Suspense } from "react";

// استدعاء المكونات Lazy
import Portoa from "./Portoa";
import Portob from "./Portob";
import Portoc from "./Portoc";

const Portfolio = () => {
  return (
    <section className="bg-gray-50 py-20" id="portfolio">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-gray-900 mb-10">
          أعمالي الفوتوغرافية
        </h2>

        {/* استخدام Suspense لتغليف المكونات Lazy */}
        {/* <Suspense fallback={<p>جاري تحميل الأعمال...</p>}> */}
          <Portoa />
          <Portob />
          <Portoc />
     
      </div>
    </section>
  );
};

export default Portfolio;
